const config ={
    appURL: process.env.REACT_APP_API_BASE_BASE_URL,
    gatewayURL: process.env.REACT_APP_API_BASE_GATEWAY_URL
};
export default config;